export class Constants {

  static readonly CLASSIFICATIONS: string[] =
    [
      'A1',
      'A2',
      'B',
      'C'
    ];

  static readonly SOURCES: string[] =
    [
      'Telefonisch',
      'Mündlich',
      'Fernüberwachung',
      'Email',
      'Schriftlich'
    ];

  static readonly INCIDENT_STATES: string[] =
    [
      'Aufgenommen',
      'Weitergeleitet',
      'In Bearbeitung',
      'Einsatz begonnen',
      'Erstsicherung abgeschlossen',
      'Dokumentation abgeschlossen',
      'Geprüft',
      'Archiviert'
    ];

}
